/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetV2ProjectsPrototypesByProjectIdAndPrototypeIdParams,
  PutV2ProjectsPrototypesByProjectIdAndPrototypeIdParams,
  DeleteV2ProjectsPrototypesByProjectIdAndPrototypeIdParams,
  GetV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdAndPageIdParams,
  PutV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdAndPageIdParams,
  GetV2ProjectsPrototypesByProjectIdParams,
  PostV2ProjectsPrototypesByProjectIdParams,
  GetV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdParams,
  PostV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdParams,
  DeleteV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdParams,
  PostV2ProjectsPrototypesMoveByProjectIdAndPrototypeIdParams,
  GetV2ProjectsReviewsByProjectIdParams,
  GetV2ProjectsPrototypesReviewsByProjectIdAndPrototypeIdParams,
  GetV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeIdAndReviewIdParams,
  GetV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeIdParams,
  GetV2ProjectsPrototypesReportShortByProjectIdAndPrototypeIdParams,
  GetV2ProjectsPrototypesPartialsByProjectIdAndPrototypeIdAndPartialIdParams,
  GetV2ProjectsPrototypesAiReviewsByProjectIdAndPrototypeIdParams,
  GetV2ProjectsPrototypesAiReviewsLatestByProjectIdAndPrototypeIdParams,
  GetV2ProjectsPrototypesAiExtendedReviewsByProjectIdAndPrototypeIdAndReviewIdParams,
  GetV2ProjectsPrototypesOptionsByProjectIdParams,
  GetV2ProjectsPrototypesNameByProjectIdParams,
  GetV2ProjectsPrototypesByProjectIdQuery,
  DeleteV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdQuery,
  GetV2ProjectsReviewsByProjectIdQuery,
  GetV2ProjectsPrototypesReviewsByProjectIdAndPrototypeIdQuery,
  GetV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeIdAndReviewIdQuery,
  GetV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeIdQuery,
  GetV2ProjectsPrototypesAiReviewsByProjectIdAndPrototypeIdQuery,
  GetV2ProjectsPrototypesAiReviewsLatestByProjectIdAndPrototypeIdQuery,
  GetV2ProjectsPrototypesNameByProjectIdQuery,
  PutV2ProjectsPrototypesByProjectIdAndPrototypeIdBody,
  PutV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdAndPageIdBody,
  PostV2ProjectsPrototypesByProjectIdBody,
  PostV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdBody,
  PostV2ProjectsPrototypesMoveByProjectIdAndPrototypeIdBody,
  GetV2ProjectsPrototypesByProjectIdAndPrototypeIdResponse,
  PutV2ProjectsPrototypesByProjectIdAndPrototypeIdResponse,
  GetV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdAndPageIdResponse,
  PutV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdAndPageIdResponse,
  GetV2ProjectsPrototypesByProjectIdResponse,
  PostV2ProjectsPrototypesByProjectIdResponse,
  GetV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdResponse,
  PostV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdResponse,
  PostV2ProjectsPrototypesMoveByProjectIdAndPrototypeIdResponse,
  GetV2ProjectsReviewsByProjectIdResponse,
  GetV2ProjectsPrototypesReviewsByProjectIdAndPrototypeIdResponse,
  GetV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeIdAndReviewIdResponse,
  GetV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeIdResponse,
  GetV2ProjectsPrototypesReportShortByProjectIdAndPrototypeIdResponse,
  GetV2ProjectsPrototypesPartialsByProjectIdAndPrototypeIdAndPartialIdResponse,
  GetV2ProjectsPrototypesAiReviewsByProjectIdAndPrototypeIdResponse,
  GetV2ProjectsPrototypesAiReviewsLatestByProjectIdAndPrototypeIdResponse,
  GetV2ProjectsPrototypesAiExtendedReviewsByProjectIdAndPrototypeIdAndReviewIdResponse,
  GetV2ProjectsPrototypesOptionsByProjectIdResponse,
  GetV2ProjectsPrototypesNameByProjectIdResponse,
} from '../types';

export class Prototypes extends Controller {
  async getV2ProjectsPrototypesByProjectIdAndPrototypeId<
    T extends GetV2ProjectsPrototypesByProjectIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
    }: GetV2ProjectsPrototypesByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}`,
      axiosConfig
    );
  }

  async putV2ProjectsPrototypesByProjectIdAndPrototypeId<
    T extends PutV2ProjectsPrototypesByProjectIdAndPrototypeIdResponse,
    D,
    C extends PutV2ProjectsPrototypesByProjectIdAndPrototypeIdBody
  >(
    body: C,
    {
      projectId,
      prototypeId,
    }: PutV2ProjectsPrototypesByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}`,
      body,
      axiosConfig
    );
  }

  async deleteV2ProjectsPrototypesByProjectIdAndPrototypeId<
    T,
    D,
    C extends null
  >(
    {
      projectId,
      prototypeId,
    }: DeleteV2ProjectsPrototypesByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}`,
      { ...axiosConfig, data: body }
    );
  }

  async getV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdAndPageId<
    T extends GetV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdAndPageIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
      pageId,
    }: GetV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdAndPageIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}/pages/${pageId}`,
      axiosConfig
    );
  }

  async putV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdAndPageId<
    T extends PutV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdAndPageIdResponse,
    D,
    C extends PutV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdAndPageIdBody
  >(
    body: C,
    {
      projectId,
      prototypeId,
      pageId,
    }: PutV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdAndPageIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}/pages/${pageId}`,
      body,
      axiosConfig
    );
  }

  async getV2ProjectsPrototypesByProjectId<
    T extends GetV2ProjectsPrototypesByProjectIdResponse,
    D,
    C
  >(
    { projectId }: GetV2ProjectsPrototypesByProjectIdParams,
    query: GetV2ProjectsPrototypesByProjectIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/v2/projects/${projectId}/prototypes`, query),
      axiosConfig
    );
  }

  async postV2ProjectsPrototypesByProjectId<
    T extends PostV2ProjectsPrototypesByProjectIdResponse,
    D,
    C extends PostV2ProjectsPrototypesByProjectIdBody
  >(
    body: C,
    { projectId }: PostV2ProjectsPrototypesByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes`,
      body,
      axiosConfig
    );
  }

  async getV2ProjectsPrototypesPagesByProjectIdAndPrototypeId<
    T extends GetV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
    }: GetV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}/pages`,
      axiosConfig
    );
  }

  async postV2ProjectsPrototypesPagesByProjectIdAndPrototypeId<
    T extends PostV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdResponse,
    D,
    C extends PostV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdBody
  >(
    body: C,
    {
      projectId,
      prototypeId,
    }: PostV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}/pages`,
      body,
      axiosConfig
    );
  }

  async deleteV2ProjectsPrototypesPagesByProjectIdAndPrototypeId<
    T,
    D,
    C extends null
  >(
    {
      projectId,
      prototypeId,
    }: DeleteV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdParams,
    query: DeleteV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      this.composeUrl(
        `/v2/projects/${projectId}/prototypes/${prototypeId}/pages`,
        query
      ),
      { ...axiosConfig, data: body }
    );
  }

  async postV2ProjectsPrototypesMoveByProjectIdAndPrototypeId<
    T extends PostV2ProjectsPrototypesMoveByProjectIdAndPrototypeIdResponse,
    D,
    C extends PostV2ProjectsPrototypesMoveByProjectIdAndPrototypeIdBody
  >(
    body: C,
    {
      projectId,
      prototypeId,
    }: PostV2ProjectsPrototypesMoveByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}/move`,
      body,
      axiosConfig
    );
  }

  async getV2ProjectsReviewsByProjectId<
    T extends GetV2ProjectsReviewsByProjectIdResponse,
    D,
    C
  >(
    { projectId }: GetV2ProjectsReviewsByProjectIdParams,
    query: GetV2ProjectsReviewsByProjectIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/v2/projects/${projectId}/reviews`, query),
      axiosConfig
    );
  }

  async getV2ProjectsPrototypesReviewsByProjectIdAndPrototypeId<
    T extends GetV2ProjectsPrototypesReviewsByProjectIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
    }: GetV2ProjectsPrototypesReviewsByProjectIdAndPrototypeIdParams,
    query: GetV2ProjectsPrototypesReviewsByProjectIdAndPrototypeIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(
        `/v2/projects/${projectId}/prototypes/${prototypeId}/reviews`,
        query
      ),
      axiosConfig
    );
  }

  async getV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeIdAndReviewId<
    T extends GetV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeIdAndReviewIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
      reviewId,
    }: GetV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeIdAndReviewIdParams,
    query: GetV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeIdAndReviewIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(
        `/v2/projects/${projectId}/prototypes/${prototypeId}/reviews/${reviewId}/events`,
        query
      ),
      axiosConfig
    );
  }

  async getV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeId<
    T extends GetV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
    }: GetV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeIdParams,
    query: GetV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(
        `/v2/projects/${projectId}/prototypes/${prototypeId}/reviews/events`,
        query
      ),
      axiosConfig
    );
  }

  async getV2ProjectsPrototypesReportShortByProjectIdAndPrototypeId<
    T extends GetV2ProjectsPrototypesReportShortByProjectIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
    }: GetV2ProjectsPrototypesReportShortByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}/report/short`,
      axiosConfig
    );
  }

  async getV2ProjectsPrototypesPartialsByProjectIdAndPrototypeIdAndPartialId<
    T extends GetV2ProjectsPrototypesPartialsByProjectIdAndPrototypeIdAndPartialIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
      partialId,
    }: GetV2ProjectsPrototypesPartialsByProjectIdAndPrototypeIdAndPartialIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}/partials/${partialId}`,
      axiosConfig
    );
  }

  async getV2ProjectsPrototypesAiReviewsByProjectIdAndPrototypeId<
    T extends GetV2ProjectsPrototypesAiReviewsByProjectIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
    }: GetV2ProjectsPrototypesAiReviewsByProjectIdAndPrototypeIdParams,
    query: GetV2ProjectsPrototypesAiReviewsByProjectIdAndPrototypeIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(
        `/v2/projects/${projectId}/prototypes/${prototypeId}/ai/reviews`,
        query
      ),
      axiosConfig
    );
  }

  async getV2ProjectsPrototypesAiReviewsLatestByProjectIdAndPrototypeId<
    T extends GetV2ProjectsPrototypesAiReviewsLatestByProjectIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
    }: GetV2ProjectsPrototypesAiReviewsLatestByProjectIdAndPrototypeIdParams,
    query: GetV2ProjectsPrototypesAiReviewsLatestByProjectIdAndPrototypeIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(
        `/v2/projects/${projectId}/prototypes/${prototypeId}/ai/reviews/latest`,
        query
      ),
      axiosConfig
    );
  }

  async getV2ProjectsPrototypesAiExtendedReviewsByProjectIdAndPrototypeIdAndReviewId<
    T extends GetV2ProjectsPrototypesAiExtendedReviewsByProjectIdAndPrototypeIdAndReviewIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
      reviewId,
    }: GetV2ProjectsPrototypesAiExtendedReviewsByProjectIdAndPrototypeIdAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}/ai/extended/reviews/${reviewId}`,
      axiosConfig
    );
  }

  async getV2ProjectsPrototypesOptionsByProjectId<
    T extends GetV2ProjectsPrototypesOptionsByProjectIdResponse,
    D,
    C
  >(
    { projectId }: GetV2ProjectsPrototypesOptionsByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/options`,
      axiosConfig
    );
  }

  async getV2ProjectsPrototypesNameByProjectId<
    T extends GetV2ProjectsPrototypesNameByProjectIdResponse,
    D,
    C
  >(
    { projectId }: GetV2ProjectsPrototypesNameByProjectIdParams,
    query: GetV2ProjectsPrototypesNameByProjectIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/v2/projects/${projectId}/prototypes/name`, query),
      axiosConfig
    );
  }
}
